<template>
  <div class="table-container have-zoom">
    <div class="addNews">
      <h1>添加新闻</h1>
      <el-form ref="form" :model="form" label-width="80px">
        <el-form-item label="新闻标题">
          <el-input v-model="form.title" :maxlength="20" placeholder="最大输入20字"></el-input>
        </el-form-item>
        <el-form-item label="新闻简介">
          <el-input v-model="form.summary" :maxlength="70" placeholder="最大输入70字"></el-input>
        </el-form-item>
        <el-form-item label="投放活动">
          <!-- <el-input v-model="form.type" placeholder="投放的活动"></el-input> -->
          <el-radio-group v-model="form.type">
            <el-radio
              v-for="(itm,idx) in $env.ARTICLE_LIST"
              :label="itm.value"
              :key="idx"
            >{{itm.name}}</el-radio>
            <!-- <el-radio label="freetalks">汇说</el-radio>
          <el-radio label="hkstocks">决战港股</el-radio>
            <el-radio label="roadshow">汇路演</el-radio>-->
          </el-radio-group>
        </el-form-item>
        <el-form-item label="活动城市">
          <el-input v-model="form.city" placeholder="活动具体城市"></el-input>
        </el-form-item>
        <el-form-item label="新闻链接">
          <el-input v-model="form.link" placeholder="新闻完整链接"></el-input>
        </el-form-item>
        <el-form-item label="新闻时间">
          <el-date-picker
            v-model="form.newsTime"
            type="date"
            placeholder="选择日期"
            format="yyyy 年 MM 月 dd 日"
            value-format="yyyy-MM-dd"
            :picker-options="pickerOptions1"
          ></el-date-picker>
        </el-form-item>
        <el-form-item label="新闻图片上传">
          <el-upload
            :action="oss.host"
            :data="oss"
            class="one-line-upload"
            :on-success="avatarSuccess"
            :on-remove="avatarRemove"
          >
            <el-button size="small" type="primary">
              上传新闻图片
              <i class="el-icon-upload el-icon--right"></i>
            </el-button>
          </el-upload>
        </el-form-item>
        <el-form-item label="新闻图片">
          <el-input v-model="form.imgUrl" placeholder="上传图片或者粘贴图片链接"/>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="pushData" v-if="!id">添加新闻</el-button>
          <el-button type="primary" @click="putData" plain v-if="id">更新新闻信息</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="showNews">
      <h1>决战港股/汇说/汇路演 效果预览</h1>
      <template>
        <el-tabs>
          <el-tab-pane label="决战港股" name="first">
            <div class="juezhan">
              <a :href="form.link">
                <img :src="form.imgUrl" alt>
              </a>
              <div>
                <a :href="form.link">
                  <h3>{{form.title}}</h3>
                </a>
                <p>{{form.summary}}</p>
                <p>{{form.newsTime}}</p>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="汇说" name="second">
            <div class="huishuo">
              <img :src="form.imgUrl" alt>
              <div>
                <h1>{{form.title}}</h1>
                <p>{{form.summary}}</p>
                <a :href="form.link">查看更多</a>
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="汇路演" name="third">
            <div class="huiluyan">
              没啥好预览的……
              <ol>
                <li>标题+图片</li>
                <li>标题+新闻时间</li>
              </ol>
            </div>
          </el-tab-pane>
        </el-tabs>
      </template>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        title: null,
        summary: null,
        city: null,
        type: null,
        newsTime: null,
        imgUrl: null,
        link: null
      },
      oss: {
        key: "",
        OSSAccessKeyId: "",
        policy: "",
        Signature: "",
        host: "",
        success_action_status: 200,
        callback: ""
      },
      pickerOptions1: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
        shortcuts: [
          {
            text: "今天",
            onClick(picker) {
              picker.$emit("pick", new Date());
            }
          },
          {
            text: "昨天",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24);
              picker.$emit("pick", date);
            }
          },
          {
            text: "一周前",
            onClick(picker) {
              const date = new Date();
              date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", date);
            }
          }
        ]
      }
    };
  },
  watch: {
    id() {
      this.getData();
    }
  },
  methods: {
    avatarSuccess(res, file, filelist) {
      if (res.statusCode === 200) {
        this.form.imgUrl = `${this.oss.host}/${res.result.filename}`;
      } else {
        this.$message({
          type: "error",
          message: "上传失败"
        });
      }
    },
    avatarRemove() {
      this.form.imgUrl = null;
    },
    getOssSign() {
      this.$http.oss_sign().then(res => {
        if (res.data.statusCode === 200) {
          this.oss.host = res.data.result.host;
          this.oss.key =
            res.data.result.dirPath + res.data.result.key + "${filename}";
          this.oss.policy = res.data.result.policy;
          this.oss.OSSAccessKeyId = res.data.result.OSSAccessKeyId;
          this.oss.Signature = res.data.result.Signature;
          this.oss.callback = res.data.result.callback;
        } else {
          this.$message({
            type: "error",
            message: "获取oss签名信息失败,请刷新重试。"
          });
        }
      });
    },
    getData(id) {
      this.$http.news_detail(id).then(res => {
        if (res.data.statusCode === 200) {
          const {
            title,
            summary,
            link,
            imgUrl,
            newsTime,
            city,
            type
          } = res.data.result;
          this.form.title = title;
          this.form.summary = summary;
          this.form.city = city;
          this.form.type = type;
          this.form.link = link;
          this.form.imgUrl = imgUrl;
          this.form.newsTime = newsTime;
        } else {
          this.form.title = null;
          this.form.summary = null;
          this.form.city = null;
          this.form.type = null;
          this.form.link = null;
          this.form.imgUrl = null;
          this.form.newsTime = null;
        }
      });
    },
    pushData() {
      this.$http
        .put_news({
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push("/news/list");
            this.$message({
              message: "新闻添加成功~",
              type: "success"
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    },
    putData() {
      this.$http
        .put_news({
          id: this.id,
          ...this.form
        })
        .then(res => {
          if (res.data.statusCode === 200) {
            this.$router.push("/news/list");
            this.$message({
              message: "新闻信息更新成功~",
              type: "success"
            });
          } else {
            this.$message.error(res.data.message);
          }
        });
    }
  },
  mounted() {
    this.getOssSign();
    if (this.id) {
      this.getData(this.id);
    }
  },
  computed: {
    id() {
      return this.$route.params.id;
    }
  }
};
</script>

<style scoped>
.one-line-upload {
  display: inline-block;
  vertical-align: top;
}
.table-container {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
.addNews {
  width: 700px;
}
.showNews {
  width: 700px;
  margin-right: 100px;
  background-color: rgb(242, 242, 242);
}

.juezhan {
  margin: 20px;
  width: 520px;
  height: 160px;
  background-color: #fff;
}
.juezhan a {
  text-decoration: none;
  color: rgb(37, 37, 37);
}
.juezhan > a > img {
  width: 160px;
  height: 160px;
  float: left;
}
.juezhan > div {
  padding-top: 5px;
  padding-left: 20px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  color: rgb(119, 119, 119);
}
.juezhan > div > h3 {
  padding-right: 5px;
  font-size: 18px;
  color: rgb(59, 59, 59);
}
.juezhan > div > p {
  font-size: 14px;
  padding-right: 12px;
}

.huishuo {
  height: 430px;
  width: 285px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin: 0 15px;
  background-color: rgba(39, 47, 120, 0.925);
}
.huishuo > img {
  width: 285px;
  height: 178px;
}
.huishuo > div {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  flex-grow: 1;
}
.huishuo > div > h1 {
  font-size: 21px;
  color: rgb(255, 211, 89);
  font-weight: 400;
  padding: 0 30px;
}
.huishuo > div > p {
  padding: 0 30px;
  color: #fff;
  font-size: 14px;
}
.huishuo > div > a {
  text-decoration: none;
  color: #000;
  background-color: rgb(255, 211, 89);
  padding: 10px 30px;
  border-radius: 10px;
}
.huiluyan {
  margin: 30px;
}
</style>



// WEBPACK FOOTER //
// src/components/backend/news-post.vue